<ng-container *ngIf="holding">
  <terra-holding-images class="image-slider" [ngClass]="{ 'example-strip': holding.id === EXAMPLE_ASSET_ID }"
                        [location]="holding.location" [holdingFiles]="holding.attachments"
                        [showText]="false">
  </terra-holding-images>

  <div class="information">

    <span class="holding-name">{{ holding.name }}</span>
    <!--<span class="organization-name">{{holding.gpDetails?.agentCompanyName}}</span> -->
    <span *ngIf="isAsset" class="bullet">
      <mat-icon class="notranslate round-icon">place</mat-icon>
      {{ getFormattedAddress(holding.location) }}
    </span>
    <span *ngIf="holding.holdingType && holding.holdingType !== HoldingType.Other " class="bullet">
      <mat-icon class="notranslate round-icon">home</mat-icon>
      <strong>Property Type:</strong> {{ holding.holdingType | enumString: HoldingType }}
    </span>
    <span *ngIf="isFund" class="bullet">
      <mat-icon class="notranslate round-icon">donut_large</mat-icon>
      <strong>Investment Strategy:</strong> {{ holdingAsFund.investmentStrategyType | enumString: FundInvestmentStrategyType }}
    </span>
    <span *ngIf="isAsset" class="bullet">
      <mat-icon class="notranslate round-icon">donut_large</mat-icon>
      <strong>Investment Type:</strong>
      {{ holdingAsAsset.investmentType !== InvestmentType.Other ? (holdingAsAsset.investmentType | enumString: InvestmentType) : holdingAsAsset.investmentTypeOther }}
    </span>
    <span *ngIf="holding.finalClosingDate" class="bullet">
      <mat-icon class="notranslate round-icon">date_range</mat-icon>
      <strong>Initial Closing Date:</strong> {{ holding.finalClosingDate | utcDate }}
    </span>

    <a *ngIf="(isFund || !holdingAsAsset.fundId) && holding.status === HoldingStatus.Owned && holding.allowLpSetBank && !isViewingAsInvestor && (investedInHolding$ | async)"
       [routerLink]="getBankAccountEditPage(holding.id)" class="action-button set-bank-account">
      <mat-icon class="notranslate">add</mat-icon>
      Set a bank account for distributions
    </a>

    <a *ngIf="hasPendingCapitalCall$ | async" (click)="navigateToCapitalCallTab(holding.id)" class="action-button go-to-capital-call">
      View Capital Call
    </a>
  </div>

</ng-container>
